import React from 'react';
import PropTypes from 'prop-types';
import SearchLoungesByAirportList from './SearchLoungesByAirportList';

const SearchPage = ({ location }) => {
  return (
    <div className="tw-mx-auto tw-max-w-screen-x2l tw-px-4 md_tw-px-6 lg_tw-px-8 xl_tw-px-10">
      <div className="tw-pt-10">
        <SearchLoungesByAirportList location={location} />
      </div>
    </div>
  );
};

SearchPage.propTypes = {
  location: PropTypes.shape({
    pathname: PropTypes.string,
    query: PropTypes.shape({}),
    search: PropTypes.string,
  }),
};

export default SearchPage;
